import styled from 'styled-components';

export const LegalPageWrapper = styled.article`
  max-width: ${({ $isPdf }) => ($isPdf ? '1100px' : '720px')};
  margin: 0 auto;
  padding: 24px 16px 48px;
`;

export const LegalDocumentTitle = styled.h1`
  margin: 0 0 20px;
  font-size: clamp(1.8rem, 3vw, 2.3rem);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: #1a1a2e;
  background: linear-gradient(90deg, #01ebb2 0%, #0d4efe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const LegalContent = styled.div`
  font-size: 1rem;
  line-height: 1.6;
  color: #333;

  h1 {
    font-size: 1.75rem;
    margin-bottom: 0.5rem;
  }

  h2 {
    font-size: 1.25rem;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }

  h3 {
    font-size: 1.1rem;
    margin-top: 1rem;
    margin-bottom: 0.25rem;
  }

  p {
    margin-bottom: 0.75rem;
  }

  ul,
  ol {
    margin-bottom: 0.75rem;
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.25rem;
  }

  hr {
    border: none;
    border-top: 2px solid #bdbdbd;
    margin: 2.5rem 0;
  }

  strong {
    font-weight: 600;
  }
`;
